import PropTypes from 'prop-types';
import { Box, Typography, LinearProgress } from '@mui/material';
import fakeData from 'features/IRWorkstation/constants/fakeData';

const ActiveRaiseContent = ({ onOpenFundV }) => {
	const { activeRaise } = fakeData;

	return (
		<Box
			sx={{
				flex: 1,
				overflowY: 'auto',
				padding: '13px 15px',
				display: 'flex',
				flexDirection: 'column',
				gap: '11px',
				cursor: 'pointer',
			}}
			onClick={onOpenFundV}
		>
			{/* kpi row 1 */}
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr)',
					gap: '8px',
				}}
			>
				<Box
					sx={{
						backgroundColor: 'background.subtle',
						borderRadius: '7px',
						padding: '9px 11px',
					}}
				>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
						}}
					>
						Committed
					</Typography>
					<Typography
						sx={{
							fontSize: '16px',
							fontWeight: 600,
							color: 'text.primary',
						}}
					>
						{activeRaise.committed}
					</Typography>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'score.up',
						}}
					>
						{activeRaise.committedSub}
					</Typography>
				</Box>
				<Box
					sx={{
						backgroundColor: 'background.subtle',
						borderRadius: '7px',
						padding: '9px 11px',
					}}
				>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
						}}
					>
						LPs closed / target
					</Typography>
					<Typography
						sx={{
							fontSize: '16px',
							fontWeight: 600,
							color: 'text.primary',
						}}
					>
						{activeRaise.lpsClosed}
					</Typography>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
						}}
					>
						{activeRaise.lpsClosedSub}
					</Typography>
				</Box>
				<Box
					sx={{
						backgroundColor: 'background.subtle',
						borderRadius: '7px',
						padding: '9px 11px',
					}}
				>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
						}}
					>
						Re-up rate
					</Typography>
					<Typography
						sx={{
							fontSize: '16px',
							fontWeight: 600,
							color: 'text.primary',
						}}
					>
						{activeRaise.reupRate}
					</Typography>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
						}}
					>
						{activeRaise.reupRateSub}
					</Typography>
				</Box>
			</Box>

			{/* progress bars */}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '3px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						fontSize: '11px',
						color: 'text.secondary',
					}}
				>
					<span>To first close ({activeRaise.firstCloseTarget})</span>
					<Typography
						component='span'
						sx={{
							fontSize: '11px',
							fontWeight: 600,
							color: 'text.primary',
						}}
					>
						{activeRaise.firstClosePercent}%
					</Typography>
				</Box>
				<LinearProgress
					variant='determinate'
					value={activeRaise.firstClosePercent}
					sx={{
						height: 6,
						borderRadius: 3,
						backgroundColor: 'background.subtle',
						'& .MuiLinearProgress-bar': {
							backgroundColor: 'signal.amber',
							borderRadius: 3,
						},
					}}
				/>
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '3px',
				}}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						fontSize: '11px',
						color: 'text.secondary',
					}}
				>
					<span>Soft circle vs. target</span>
					<Typography
						component='span'
						sx={{
							fontSize: '11px',
							fontWeight: 600,
							color: 'text.primary',
						}}
					>
						{activeRaise.softCircleLabel}
					</Typography>
				</Box>
				<LinearProgress
					variant='determinate'
					value={100}
					sx={{
						height: 6,
						borderRadius: 3,
						backgroundColor: 'background.subtle',
						'& .MuiLinearProgress-bar': {
							backgroundColor: 'signal.green',
							borderRadius: 3,
						},
					}}
				/>
			</Box>

			{/* kpi row 2 */}
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: 'repeat(3, 1fr)',
					gap: '8px',
				}}
			>
				<Box
					sx={{
						backgroundColor: 'background.subtle',
						borderRadius: '7px',
						padding: '9px 11px',
					}}
				>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
							mb: '1px',
						}}
					>
						First close
					</Typography>
					<Typography
						sx={{
							fontSize: '13px',
							fontWeight: 600,
							color: 'text.primary',
						}}
					>
						{activeRaise.firstCloseDate}
					</Typography>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
							mt: '1px',
						}}
					>
						{activeRaise.firstCloseDays}
					</Typography>
				</Box>
				<Box
					sx={{
						backgroundColor: 'background.subtle',
						borderRadius: '7px',
						padding: '9px 11px',
					}}
				>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
							mb: '2px',
						}}
					>
						Confidence
					</Typography>
					<Typography
						sx={{
							fontSize: '13px',
							fontWeight: 600,
							color: 'score.warn',
						}}
					>
						{activeRaise.confidence}
					</Typography>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
							mt: '1px',
						}}
					>
						AIMe · daily
					</Typography>
				</Box>
				<Box
					sx={{
						backgroundColor: 'background.subtle',
						borderRadius: '7px',
						padding: '9px 11px',
					}}
				>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'text.secondary',
							mb: '2px',
						}}
					>
						VDR signals
					</Typography>
					<Typography
						sx={{
							fontSize: '13px',
							fontWeight: 600,
							color: 'vdr.text',
						}}
					>
						{activeRaise.vdrSignals}
					</Typography>
					<Typography
						sx={{
							fontSize: '11px',
							color: 'vdr.text',
							mt: '1px',
						}}
					>
						↔ open →
					</Typography>
				</Box>
			</Box>

			{/* enter fund V CTA */}
			<Box
				sx={{
					padding: '8px',
					textAlign: 'center',
					fontSize: '12px',
					fontWeight: 500,
					color: 'status.blue.text',
					border: '0.5px solid',
					borderColor: 'status.blue.border',
					borderRadius: '7px',
					cursor: 'pointer',
					background: 'transparent',
					mt: '2px',
					'&:hover': { backgroundColor: 'status.blue.bg' },
				}}
			>
				Enter Fund V raise dashboard →
			</Box>
		</Box>
	);
};

ActiveRaiseContent.propTypes = {
	onOpenFundV: PropTypes.func.isRequired,
};

export default ActiveRaiseContent;
